<template>
  <div class="content">
    <!-- <header>
      <i class="iconfont icon-home_location_icon_l" @click="returnBack"></i>
      <p>提交成功</p>
    </header>-->
    <h5-header :header-msg="headerMsg"></h5-header>
    <div class="cont">
      <i class="iconfont icon-jinduquerentubiao success"></i>
      <p>成功提交入驻申请</p>
      <p>平台将1-3个工作日内联系你</p>
      <van-button type="info" class="btn return" @click="download" :url="urls">下载悦卖APP</van-button>
      <van-button type="info" plain class="btn" @click="returnIndex">返回首页</van-button>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      headerMsg: {
        title: "提交成功",
        url: "/joinup"
      },
      urls:''
    };
  },
  mounted() {},
  methods: {
    returnIndex() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
        // wx.miniProgram.getEnv(function(res) {
        //   if (res.miniprogram) {
        //     //小程序环境下逻辑
        //   } else {
        //     //非小程序环境下逻辑
        //   }
        // });
      } else {
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          window.Android.goAppIndex();
        } else {
          // ios环境
          window.webkit.messageHandlers.goAppIndex.postMessage("");
        }
      }
    },
    download() {
      var ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) == "micromessenger") {
        //微信环境
        // wx.miniProgram.getEnv(function(res) {
        //   if (res.miniprogram) {
        //     //小程序环境下逻辑
        //   } else {
        //     //非小程序环境下逻辑
        //   }
        // });
      } else {
        //非微信环境逻辑
        let u = navigator.userAgent,
          app = navigator.appVersion;
        let isAndroid = u.indexOf("Android") > -1 || u.indexOf("Linux") > -1; //android终端或者uc浏览器
        let isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
        let isOS = isAndroid ? true : false;
        if (isOS) {
          // Android环境
          //   window.Android.returnIndex();
          this.urls =
            "https://sj.qq.com/myapp/detail.htm?apkName=com.daogj.seller";
        } else {
          // ios环境
          // window.webkit.messageHandlers.download.postMessage("");
          this.urls =
            "https://itunes.apple.com/cn/app/%E6%82%A6%E5%8D%96/id1326702520?mt=8";
        }
      }
    },
    // returnBack() {
    //   this.$router.push({
    //     path: "/joinup",
    //     query: {
    //       type: this.GetQueryString("type"),
    //       refereeId: this.GetQueryString("refereeId"),
    //       wx: this.GetQueryString("wx") || "1"
    //     }
    //   }); //跳转
    // }
  }
};
</script>

<style lang="scss" scoped>
.content {
  
  .cont {
    p {
      font-size: 16px;
      text-align: center;
      line-height: 16px;
    }
    .success {
      display: block;
      font-size: 88px;
      color: #4ecb74;
      margin: 104px auto 32px;
    }

    .btn {
      width: 231px;
      height: 44px;
      border-radius: 25px;
    }
    .return {
      margin: 40px auto 21px;
    }
  }
}
</style>
